export default __webpack_public_path__ + "static/media/delete_icon.3fde034d.svg";